import { useParams } from "react-router-dom"
import { Container, Row, Col, Button, Stack } from "react-bootstrap"
import { useGetIntegrationByIdQuery } from "../../../services/bClientApi"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import DataLogList from "../../../Components/DataLogs/DataLogList"
import PropertyTitleText from "../../../Components/PropertyEntry/PropertyTitleText"

export default function IntegrationPage() {
    const { integrationId = '' } = useParams()
    const dispatch = useAppDispatch()

    const {
        data,
        error,
        isLoading
    } = useGetIntegrationByIdQuery(integrationId, { skip: !integrationId })
    const integrationData = data || {}

    return (
        <Container>
            <Row>
                <Col xs={12} lg={9}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>Integration Details</h1>
                        <Stack direction="horizontal" gap={2}>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => dispatch(navigateTo(`/edit-integration/${integrationId}`))}
                            >
                                Edit
                            </Button>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => dispatch(navigateTo(`/delete-integration/${integrationId}`))}
                            >
                                Delete
                            </Button>
                        </Stack>
                    </div>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {integrationId && integrationData && integrationData._id && !isLoading && (
                        <div>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Provider</strong></Col>
                                <Col xs={8}>{integrationData.provider}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Entity Type</strong></Col>
                                <Col xs={8}>{integrationData.entityType}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Entity ID</strong></Col>
                                <Col xs={8}>
                                    <code>{integrationData.entityId}</code>
                                    {integrationData.entityType === 'property' && (
                                        <span className="ms-2">
                                            (<PropertyTitleText propertyId={integrationData.entityId} />)
                                        </span>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Primary External ID</strong></Col>
                                <Col xs={8}><code>{integrationData.primaryExternalId}</code></Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>External IDs</strong></Col>
                                <Col xs={8}>
                                    <pre className="mb-0" style={{ fontSize: '0.85em' }}>
                                        {JSON.stringify(integrationData.externalIds, null, 2)}
                                    </pre>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Override Data</strong></Col>
                                <Col xs={8}>
                                    <pre className="mb-0" style={{ fontSize: '0.85em' }}>
                                        {JSON.stringify(integrationData.overrideData, null, 2)}
                                    </pre>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Sync Status</strong></Col>
                                <Col xs={8}>{integrationData.sync?.status}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Last Synced At</strong></Col>
                                <Col xs={8}>{integrationData.sync?.lastSyncedAt ? new Date(integrationData.sync.lastSyncedAt).toLocaleString() : '—'}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Last Attempt At</strong></Col>
                                <Col xs={8}>{integrationData.sync?.lastAttemptAt ? new Date(integrationData.sync.lastAttemptAt).toLocaleString() : '—'}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Last Error</strong></Col>
                                <Col xs={8}>{integrationData.sync?.lastError || '—'}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Raw Data</strong></Col>
                                <Col xs={8}>
                                    <pre className="mb-0" style={{ fontSize: '0.85em' }}>
                                        {JSON.stringify(integrationData.rawData, null, 2)}
                                    </pre>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Created At</strong></Col>
                                <Col xs={8}>{integrationData.createdAt ? new Date(integrationData.createdAt).toLocaleString() : '—'}</Col>
                            </Row>
                            <Row className="mb-2">
                                <Col xs={4}><strong>Updated At</strong></Col>
                                <Col xs={8}>{integrationData.updatedAt ? new Date(integrationData.updatedAt).toLocaleString() : '—'}</Col>
                            </Row>
                        </div>
                    )}
                </Col>

                <Col xs={12} lg={3}>
                    <DataLogList
                        dataType="integration"
                        dataId={integrationId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
